import { render, staticRenderFns } from "./travel-guide-modal.vue?vue&type=template&id=e461666c&scoped=true"
import script from "./travel-guide-modal.vue?vue&type=script&lang=js"
export * from "./travel-guide-modal.vue?vue&type=script&lang=js"
import style0 from "./travel-guide-modal.vue?vue&type=style&index=0&id=e461666c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e461666c",
  null
  
)

export default component.exports